<p-blockUI [blocked]="loading" />
<p class="commercial-outage-disclaimer">
  This page may contain confidential operational, customer and market-sensitive
  information intended only for authorized personnel. Do not share, distribute
  or discuss any content from this page with individuals who do not have
  appropriate authorization.
</p>
<div id="commercial-outage-action-buttons">
  <div class="buttons">
    @if (canAddCommercialOutage()) {
      <button
        pButton
        label="{{ 'COMMON.LABEL.BUTTONS.NEW' | translate }}"
        icon="fa fa-fw fa-plus"
        (click)="addNewCommercialOutage()"
      ></button>
    }
    <button
      pButton
      class="refresh-button"
      icon="fa fa-fw fa-refresh"
      aria-label="{{ 'COMMON.LABEL.BUTTONS.REFRESH' | translate }}"
      (click)="refresh()"
    ></button>
    <button
      pButton
      label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
      icon="fa fa-fw fa-eraser"
      (click)="clearScreen()"
    ></button>
  </div>
</div>

<app-progress-spinner [enabled]="loading && elements.length === 0" />
<div [style.display]="loading && elements.length === 0 ? 'none' : ''">
  <app-general-grid
    #grid
    [values]="elements"
    [columns]="columns"
    [loading]="loading"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [filterable]="true"
    [screenName]="screenName"
    [lazy]="true"
    (lazyLoad)="lazyLoad($event)"
    (changeViewEvent)="changeViewEvent($event)"
    [includeExportCSV]="false"
    [scrollHeight]="scrollHeight"
    [usePaginator]="true"
    [rowsPerPageOptions]="[50, 100, 200]"
  />
</div>
